// _TODO: Переписать на нормальный задокументированный код
import Observer from '@/common/scripts/observer';
import {Utils} from '@/common/scripts/utils';

const observer = new Observer();

const finishingFlat = document.querySelector('.j-flat-finishing');

if (finishingFlat) {
    const inputs = Array.from(finishingFlat.querySelectorAll('input'));
    // Кнопки вызова попапа с дата атрибутом отделки
    const popupButtons = Array.from(document.querySelectorAll('.j-popup[data-finishing-input]'));

    // Подставляем значение в кнопки
    const changeButtonValue = (value) => {
        popupButtons.forEach((button) => {
            button.dataset.finishingInput = value;
        });
    };

    inputs.forEach((input) => {
        input.addEventListener('change', () => {
            observer.publish('outsideTabChange', input.value);
            changeButtonValue(input.value);
        });
    });

    observer.subscribe('tabChange', (tab) => {
        const isFlatFinishingTab = tab.dataset.flatTab || false;
        let activeTab = tab.dataset.tab;

        // Так как табы отделки могут быть внутри, сначала проверяем там на который кликнули
        // если это не таб с отделкой, то пробуем найти там с отделкой внутри, и если находим меняем
        // отделку квартиры на первый таб с отделкой внутри
        if (!isFlatFinishingTab) {
            const innerTab = tab.querySelector('.j-tabs__item.is-active');

            if (!innerTab) {
                return;
            }

            activeTab = innerTab.dataset.tab;
        }

        inputs.forEach((input) => {
            input.checked = input.value === activeTab;
        });

        changeButtonValue(activeTab);
    });

    // Подписка на открытие попапов
    observer.subscribe('popup:open', (popup) => {
        if (!popup.content) {
            return;
        }

        const finishing = popup.content.querySelector('.j-finishing');

        if (!finishing) {
            return;
        }

        const tabs = Array.from(finishing.querySelectorAll('.j-tabs__item'));

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                observer.publish('outsideTabChange', tab.dataset.tab);
            });
        });
    });
}

document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
        const plansScroll = Array.from(document.querySelectorAll('.j-flat-plan-scroll'));

        plansScroll.forEach((plan) => {
            plan.scrollLeft = plan.offsetWidth / 2;
        });
    }
};

const getNewViewers = () => {
    return Math.floor((Math.random() * (50 - 10)) + 10);
};

const viewersText = document.querySelector('.j-flat-viewers-label');

if (viewersText) {
    const viewersPhrase = 'чел. сейчас меняют планировку';
    const viewers = Number(Utils.getCookie('viewers')) || false;

    const setOnEmptyCookie = () => {
        const newViewers = getNewViewers();

        viewersText.textContent = `${newViewers} ${viewersPhrase}`;
        Utils.setCookie('viewers', newViewers);
    };

    if (viewers && viewers < 98) {
        viewersText.textContent = `${Number(viewers) + 1} ${viewersPhrase}`;
        Utils.setCookie('viewers', Number(viewers) + 1);
    } else {
        setOnEmptyCookie();
    }
}
